<!--
 * @Author: zd
 * @Date: 2020-07-22 16:46:37
 * @LastEditTime: 2021-11-24 10:17:19
 * @LastEditors: Please set LastEditors
 // background-color : #ffffff;
    // border-radius :  50px 50px 50px 50px;
 * @Description: 复合题 M 复合题中可能包含其他五种题型
 * @FilePath     : \vue-gaokao-ebook\src\components\paper\question\assessment\composite_assessment_result.vue
--> 
<template>
  <div class="composite_question" :id="`anchor${question.id}`">
    <!-- 标题 -->
    <div
      class="question_type"
      :style="
        subjectId != 9 && subjectId != 11
          ? 'background-color: #ffffff;border-radius :  50px 50px 50px 50px;'
          : ''
      "
    >
      <template
        v-if="question.subQuestions.length && subjectId != 9 && subjectId != 11"
      >
        <div class="id" v-html="`${question.originalName}`"></div>
        <div class="cricle"></div>
        <div class="mask"></div>
      </template>
      <div class="name">
        题型: {{ filterType(question.typeId) }}
        <span class="score"
          >分数 :
          {{
            question.typeId == 229 || question.typeId == 234
              ? question.subQuestions[0].score
              : scoreAll
          }}</span
        >
      </div>
      <!-- 字号功能 -->
      <div
        class="expert-explain"
        v-if="
          question.videoList != null &&
          question.videoList.length > 0 &&
          appId == 100
        "
      >
        <!-- && model != 'client' -->
        <el-button @click="getExplainVideo(question.videoList)"
          >专家精讲</el-button
        >
      </div>
      <div class="demo-input-suffix divs">
        <span class="text">字号：</span>
        <el-select
          popper-class="font-set"
          v-model="setFontSize"
          placeholder="请选择"
          @change="selectFontSize"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- 题的内容 -->
    <div class="question_content">
      <div class="topic" :style="`font-size:${setFontSize}px`">
        <div class="text" v-html="manipulateDataOptions(question.stem)"></div>
        <br />
        <vue-audio
          v-if="question.listeningPath"
          :key="question.listeningPath"
          :url="`${backURL}/apis/upload/${question.listeningPath}`"
          :duration="question.duration"
          :qid="question.id"
        ></vue-audio>
      </div>
    </div>
    <!-- 作答区 -->
    <div class="composite_answer_area">
      <div class="tabs_nav">
        <!-- <div class="text"></div>
        <div class="numbers">
          <div v-for="(sub, index) in this.question.subQuestions" :key="index" :class="['number-box', {'number-box-active' : sub.original == tab} ]">
            <el-button
              :class="{'c_number' : sub.original == tab,'number' :  sub.original != tab}"
              @click="chooseTab(sub.original,sub.id)"
              v-text="sub.originalName"
            ></el-button>
           
          </div>
        </div> -->
        <el-tabs
          :tab-position="`top`"
          v-model="tabPosition"
          style="width: 100%; height: 100%"
          type="border-card"
          @tab-click="changeTabs"
        >
          <el-tab-pane
            v-for="(sub, index) in this.question.subQuestions"
            :key="index"
            :label="sub.originalName"
            :name="sub.originalName"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div></div>
      <div
        class="answer"
        v-for="(sub, index) in this.question.subQuestions"
        :key="index"
        :id="`sticky${sub.id}`"
      >
        <baseQuestion
          v-show="sub.original == tab"
          :composite-name="questionTypeName"
          :isShowCorrectBtn="isShowCorrectBtn"
          :font-size="setFontSize"
          :isShowAnswerArea="isShowAnswerArea"
          :is-composite="true"
          :question="sub"
          :selfAssessment="selfAssessment"
          :is-show-self-answer="isShowSelfAnswer"
          :isDisable="isDisable"
        ></baseQuestion>
      </div>
    </div>

    <!-- 视频精讲 -->
    <el-dialog
      v-dialogDrag
      :title="pTitle"
      :modal="false"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      custom-class="explain-dialog"
      @close="closeVideos"
    >
      <video-player
        :video-list="videoList"
        :close-video="closeVideo"
      ></video-player>
    </el-dialog>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import vueAudio from "@/components/audio/index";
import affix from "@/components/affix/affix";
import questionHandle from "@/assets/js/question-handle";
import correctionAnswerArea from "@/components/paper/question/answer_area/correction_answer_area";
import baseAnswerArea from "@/components/paper/question/answer_area/base_answer_area";
import baseTitle from "@/components/paper/question/title/base_title";
import baseQuestion from "@/components/paper/question/question/result_question";
import typeNameMap from "@/assets/js/composite_question_type.js";
import { dataKatex } from "@/mixins/data-katex.js";
import videoPlayer from "@/components/video-player/index";
export default {
  name: "composite_question_result",
  components: {
    baseTitle,
    baseAnswerArea,
    correctionAnswerArea,
    baseQuestion,
    affix,
    videoPlayer,
    vueAudio
  },
  data() {
    return {
      appId: 0,
      model: "",
      pTitle: "专家精讲",
      closeVideo: false,
      videoList: [],
      dialogVisible: false,
      tabPosition: 0,
      tab: 1,
      setFontSize: 20,
      affixShow: false,
      backURL: this.$config.backURL,
      options: [
        {
          value: 18,
          label: "小"
        },
        {
          value: 20,
          label: "标准"
        },
        {
          value: 22,
          label: "大"
        },
        {
          value: 24,
          label: "较大"
        },
        {
          value: 26,
          label: "超大"
        }
      ],
      questionTypeName: "复合题",
      scoreAll: 0
    };
  },
  mixins: [dataKatex],
  props: {
    question: {
      type: Object
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    selfAssessment: {
      type: Boolean,
      default: false
    },
    isShowSelfAnswer: {
      type: Boolean,
      default: false
    },
    isShowAnswerArea: {
      type: Boolean,
      default: true
    },
    isShowCorrectBtn: {
      type: Boolean,
      default: true
    },
    subjectId: {
      type: Number
    }
  },
  methods: {
    getExplainVideo(videoList) {
      // let key = CryptoJS.enc.Utf8.parse("4&U*(hjfa*((8934");
      // let iv = CryptoJS.enc.Utf8.parse("fads()8&&O0)213j");
      // let data = []
      // for (let i = 0; i < videoList.length; i++) {
      //   const element = videoList[i].path;
      //     let decrypt = CryptoJS.AES.decrypt(element, key, {
      //       iv: iv,
      //       mode: CryptoJS.mode.CBC,
      //       padding: CryptoJS.pad.Pkcs7
      //     })
      //     let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8).toString();
      //     data.push({
      //       path: decryptedStr,
      //       title: videoList[i].title,
      //       id: videoList[i].id
      //     })
      // }
      let data = [];
      for (let i = 0; i < videoList.length; i++) {
        const element = videoList[i];
        data.push({
          path: element.path,
          title: element.title,
          id: element.id
        });
      }
      console.log("data ==>", data);
      this.videoList = data;
      this.dialogVisible = true;
    },
    closeVideos() {
      this.closeVideo = !this.closeVideo;
    },
    changeTabs(val) {
      for (let i = 0; i < this.question.subQuestions.length; i++) {
        const element = this.question.subQuestions[i];
        if (element.originalName == val.label) {
          this.chooseTab(element.original);
        }
      }
    },
    selectFontSize(val) {
      this.$root.eventHub.$emit("fontsize", val);
    },
    filterType(key) {
      let reStr = "复合题";
      for (let i in typeNameMap) {
        if (i == key) {
          reStr = typeNameMap[i];
          this.questionTypeName = reStr;
        }
      }
      return reStr;
    },
    changeAffix(affixed) {
      this.affixShow = affixed;
    },
    formatQuestion(ques) {
      this.question = questionHandle.formatQuestion(ques);
    },
    chooseTab(param) {
      this.tab = param;
      this.$root.eventHub.$emit("question-tab-changed1", param);
    }
  },
  watch: {
    question: function(newVal) {
      this.formatQuestion(newVal);
    }
  },
  created() {
    this.appId = this.$route.query.app_id || 0;
    this.model = localStorage.getItem("model") || "";
    // this.$nextTick(() => {
    //   this.question.subQuestions.forEach((element) => {
    //     this.question.score += element.score;
    //   });
    // });
    this.$nextTick(() => {
      this.question.subQuestions.forEach(element => {
        this.scoreAll += element.score;
      });
    });
  },
  mounted() {
    this.formatQuestion(this.question);
    // this.tab = this.question.subQuestions[0].original;
    // this.question.subQuestions.forEach(item=>{
    //     this.tab = item.original;
    //     return;
    // });
    this.tab = this.question.subQuestions[0].original;
    this.tabPosition = this.question.subQuestions[0].originalName;
    //监控答题卡传过来的question id
    this.$root.eventHub.$on("question-tab-changed", (val, id) => {
      this.question.subQuestions.forEach(item => {
        if (item.original == val) {
          this.tab = val;
          let top = document.getElementById("anchor" + this.question.id)
            .offsetTop;
          scrollTo(0, top);
          this.tabPosition = item.originalName;
        }
      });
    });
    this.$root.eventHub.$on("fontsize", size => {
      this.setFontSize = size;
    });
  }
};
</script>

<style lang="stylus" scoped>
.composite_question {
  margin-top: 30px;
  margin-left: 50px;
  width: 1506px;
  position: relative;
  border-radius: 0 0 50px 0;
  background-color: #ffffff;
  border: 2px solid #dddddd;
  border-bottom: none;

  .question_type {
    width: 1490px;
    position: absolute;
    top: 20px;
    height: 60px;
    margin-left: -29px;
    z-index: 10;

    .cricle {
      width: 60px;
      height: 60px;
      border-radius: 30px;
      border: 2px solid #dddddd;
      position: absolute;
      z-index: 0;
      margin: 0;
      padding: 0;
    }

    .mask {
      z-index: 9;
      width: 30px;
      height: 60px;
      background-color: #ffffff;
      margin-left: 30px;
      position: absolute;
    }

    .id {
      z-index: 10;
      min-width: 47px;
      width: auto;
      height: 47px;
      border-radius: 47px;
      background-color: #7eb8ff;
      margin-top: 6.5px;
      color: #ffffff;
      font-size: 19px;
      font-weight: 450;
      letter-spacing: 1px;
      line-height: 47px;
      text-align: center;
      position: absolute;
      float: left;
      margin-left: 6.5px;
    }

    .name {
      width: calc(100% - 250px);
      font-size: 24px;
      color: #ababab;
      position: absolute;
      float: left;
      margin-top: 14px;
      margin-left: 120px;
    }

    .score {
      margin-left: 95px;
    }

    .divs {
      float: right;
      margin-right: 30px;

      /deep/ .el-select {
        width: 120px;

        .el-input.is-focus .el-input__inner {
          border-color: #5c307d;
        }

        .el-input__inner {
          font-size: 16px;
        }
      }

      .text {
        font-size: 24px;
        color: #ababab;
      }
    }
  }

  .question_content {
    height: 445px;

    .topic {
      position: relative;
      width: 1400px;
      margin-top: 10px;
      margin-left: 15px;
      color: #3c3c3c;
      float: left;
      margin-left: 50px;
      line-height: 1.5;
      white-space: pre-line;
      word-break: break-all;
      overflow-wrap: break-word;
      word-break: noraml;
      max-height: 445px;
      overflow: auto;
      margin-top: 80px;

      >>> .text {
        font-family: 'Times New Roman', 'Microsoft YaHei', SimHei;
        font: 'Times New Roman', 'Microsoft YaHei', SimHei;

        /deep/ p {
          word-break: break-word;
          overflow-wrap: break-word;
          white-space: normal;
        }

        /deep/ p span {
          word-break: break-word;
          overflow-wrap: break-word;
          white-space: normal;
        }
      }

      >>> img {
        vertical-align: middle;
      }
    }
  }

  .composite_answer_area {
    margin-left: 0px;

    .tabs_nav {
      width: 100%;
      height: 60px;
      font-size: 18px;
      color: #585858;
      overflow: hidden;
      clear: both;
      white-space: nowrap;
      border-top: 2px #e8c9ff solid;
      background-color: #f6eeff;
      margin-top: 20px;

      /deep/ .el-tabs__header {
        height: 100%;

        .el-tabs__nav-wrap {
          height: 100%;

          .el-tabs__nav-next, .el-tabs__nav-prev {
            line-height: 50px !important;
          }

          .el-tabs__nav-next {
            right: 5px;
            top: 4px;
            background-color: #efefef;
          }

          .el-tabs__nav-prev {
            left: 5px;
            top: 4px;
            background-color: #efefef;
          }

          .el-tabs__nav-scroll {
            height: 100%;

            .el-tabs__nav {
              height: 100%;

              .el-tabs__item {
                height: 100%;
                font-size: 20px;
                border-left: 1px solid #ddd;
                line-height: 56px !important;
              }

              .el-tabs__item:last-child {
                border-right: 1px solid #ddd;
              }
            }
          }
        }
      }

      .numbers {
        height: 55px;
        line-height: 50px;
        color: #585858;
        white-space: nowrap;
        overflow-x: auto;
        overflow-y: hidden;

        >>> .el-button {
          font-size: 24px !important;
          padding: 0 !important;
          text-align: center;
          margin-left: 20px;
        }

        .number-box {
          // text-align : center;
          // background-color: #efefef;
          // width: 39px;
          // height: 39px;
          // border: 1px solid #aaaaaa;
          // border-bottom: 1px solid #5c307d;
          // float: left;
          // display: inline-block;
          // border-radius: 8px 8px 0 0;
          // margin-right: 9px;
          display: inline-block;
        }

        .number-box-active {
          border-bottom: 1px solid #ffffff;
        }

        .number {
          position: relative;
          height: 39px;
          width: 60px;
          text-align: center;
          background-color: #ffffff;
          cursor: pointer;
          color: #585858;
          border-radius: 25px;
          // margin-left : 20px;
          margin-top: 9px;
        }

        .c_number {
          position: relative;
          height: 39px;
          width: 60px;
          text-align: center;
          background-color: #7eb8ff;
          color: #ffffff;
          cursor: pointer;
          border-radius: 25px;
          margin-top: 9px;
        }
      }
    }
  }
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 4px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.expert-explain {
  float: right;

  /deep/ .el-button {
    height: 40.5px;
    width: 120px;
    font-size: 16px;
    float: right;
    background-color: #5c307d;
    color: #fff;
  }

  /deep/ .el-button:hover {
    background-color: #ff3a00;
  }
}
</style>
<style lang="stylus" scoped>
.nodata {
  color: #fff !important;
  background-color: #aaa !important;
}

>>> .explain-dialog {
  width: 1200px;
  height: auto;

  .el-dialog__header {
    padding: 0 20px;
    background-color: #5c307d;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    .el-dialog__title {
      height: 40px;
      line-height: 40px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 7px;

      .el-dialog__close {
        color: #fff;
        font-size: 28px;
      }
    }
  }

  .el-dialog__body {
    padding: 0;

    video {
      width: 100%;
    }
  }
}
</style>

